// src/libs/mixins/remittanceReasons.js
export const REMITTANCE_REASONS = [
  "School aid",
  "Family assistance",
  "Building construction",
  "Business settlement",
  "Service settlement",
  "Debt repayment",
  "Savings group",
  "Medical expenses",
  "Salary",
  "Solidarity fund",
  "Medical assistance",
  "Transport",
  "Tuition fees",
];
